import { Component, HostBinding, Input } from '@angular/core';
import { MuiColor } from '../../utility';

export enum MuiLegacyButtonAppearance {
  DEFAULT = 'default',
  GHOST = 'ghost',
  OUTLINE = 'outline'
}

const isValidEnumValue = (en: Record<string, unknown>, val: any): boolean => !!val && Object.values(en).includes(val);

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[mui-legacy-btn], a[mui-legacy-btn]',
  exportAs: 'muiLegacyButton',
  templateUrl: './mui-legacy-button.component.html'
})
export class MuiLegacyButton {
  @Input()
  set disabled(disabled: boolean) {
    this._disabled = disabled;
  }

  get disabled(): boolean {
    return this._disabled || this.working || false;
  }

  @HostBinding('attr.disabled')
  protected get disabledAttr(): true | null {
    return this.disabled || null;
  }

  @HostBinding('class') get buttonConfigClass() {
    const classes = [
      this.class, // include original classes from the DOM element
      'mui-legacy-btn',
      `mui-legacy-btn--${isValidEnumValue(MuiColor, this.color) ? this.color : MuiColor.DEFAULT}`
    ];

    if (isValidEnumValue(MuiLegacyButtonAppearance, this.appearance) && this.appearance !== MuiLegacyButtonAppearance.DEFAULT) {
      /* The next line ensures that the string value is taken from the enum, no matter if the input was a string or number */
      classes.push(`mui-legacy-btn--${this.appearance}`);
    }

    return classes.join(' ');
  }

  @Input() color: MuiColor | string = MuiColor.DEFAULT;
  @Input() appearance: MuiLegacyButtonAppearance | string = MuiLegacyButtonAppearance.DEFAULT;
  @Input() icon?: string;

  /** Sets the icon to a loading spinner and disables the button. */
  @Input() working = false;

  @Input() class = '';
  private _disabled = false;
}
